import React from "react";
import "./Layton.scss";
import data from "./data.json";
import Card from "../../../Component/Card/card";
import Layton12images from "../../../Media/BSD/Navapark/Layton12";
import Layton15images from "../../../Media/BSD/Navapark/Layton15";
import Layton15Roofimages from "../../../Media/BSD/Navapark/Layton15Rooftop";

const imageMap = {
  Layton12images,
  Layton15images,
  Layton15Roofimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="Welton" className="produk">
      <h1>Welcome to Layton</h1>
      <h2>Cicilan Start 70 Juta/Bulan</h2>
      <div className="cardhome-containerf">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
